import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { actsApi } from '@/api/acts';

export function useActs(leaseId: number | null) {
  return useQuery({
    queryKey: ['acts', leaseId],
    queryFn: () => actsApi.listForLease(leaseId as number),
    enabled: leaseId !== null,
  });
}

export function useAct(id: number | null) {
  return useQuery({
    queryKey: ['act', id],
    queryFn: () => actsApi.get(id as number),
    enabled: id !== null,
  });
}

export function useTenantResponse(actId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (form: FormData) => actsApi.tenantResponse(actId, form),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['act', actId] });
      void qc.invalidateQueries({ queryKey: ['acts'] });
    },
  });
}

export function useInitiateSigning() {
  return useMutation({
    mutationFn: (documentId: number) => actsApi.initiateSigning(documentId),
  });
}

export function useSendSigningSms() {
  return useMutation({
    mutationFn: (documentId: number) => actsApi.signingSendSms(documentId),
  });
}
